module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component component-backoffice-note-form"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns small-12"
  }, [_c('label', [_vm._v("Valid from"), _c('DatePicker', {
    model: {
      value: (_vm.note.valid_from),
      callback: function($$v) {
        _vm.$set(_vm.note, "valid_from", $$v)
      },
      expression: "note.valid_from"
    }
  })], 1), _c('label', [_vm._v("Valid to"), _c('DatePicker', {
    model: {
      value: (_vm.note.valid_to),
      callback: function($$v) {
        _vm.$set(_vm.note, "valid_to", $$v)
      },
      expression: "note.valid_to"
    }
  })], 1), _c('label', [_vm._v("Description"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note.description),
      expression: "note.description"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.note.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.note, "description", $event.target.value)
      }
    }
  })]), _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": !_vm.note.description
    },
    on: {
      "click": _vm.noteCompleted
    }
  }, [_vm._v("Create")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0eec72cd!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/NoteForm.vue
// module id = 2262
// module chunks = 1